<template>
  <DataTable ref="dataTable" :columns="columnList" defaultColumnOrderDir="ASC" :defaultColumnOrderIndex="1" :url="dataURL">
    <template v-slot:title>
      
    </template>
    <template v-slot:row="row">
      <tr :key="row.data.id">
        <td width="20px">
          <Tooltip v-if="!isUnchangedList && row.data.isAutoGenerated" label="Sales price automatically generated based on modifiers">
            <Icon iconStyle="far" icon="fa-info-circle" iconClass="text-muted" fixedWidth />
          </Tooltip>          
        </td>
        <td class="table-data-nav-link">
          <LinkStock :id="row.data.stockId" :name="`${row.data.stockCode} - ${row.data.stockName}`" />
        </td>
        <td>
          {{priceInfoName(row.data)}}
        </td>
        <td>
          <span v-if="priceHasField(row.data, 'isActive')">
            <span v-html="displayPriceActiveChange(isUnchangedList ? row.data.isActive : row.data.currentIsActive, row.data.isActive)"></span>
          </span>
          <span v-else>
            -
          </span>
        </td>
        <td>
          <span v-if="priceHasField(row.data, 'price')">
            <span v-html="displayPriceChange(isUnchangedList ? row.data.price : row.data.currentPrice, row.data.price, row.data.stockUOMType)"></span>
          </span>
          <span v-else>
            -
          </span>          
        </td>
        <td>
          <span v-if="priceHasField(row.data, 'minChargeQuantity')">
            <span v-html="displayValueChange(isUnchangedList ? row.data.minChargeQuantity : row.data.currentMinChargeQuantity, row.data.minChargeQuantity)"></span>
          </span>
          <span v-else>
            -
          </span>          
        </td>
        <td>
          <span v-if="priceHasField(row.data, 'minChargePrice')">
            <span v-html="displayPriceChange(isUnchangedList ? row.data.minChargePrice : row.data.currentMinChargePrice, row.data.minChargePrice)"></span>
          </span>
          <span v-else>
            -
          </span>
        </td>
        <td>
          <span v-if="priceHasField(row.data, 'minChargeInvoice')">
            <span v-html="displayPriceChange(isUnchangedList ? row.data.minChargeInvoice : row.data.currentMinChargeInvoice, row.data.minChargeInvoice)"></span>
          </span>
          <span v-else>
            -
          </span>          
        </td>
        <td>
          <ActionDropMenu :tableAction="true" :forceDropdown="true" v-if="canEditSalesPrice">
            <DropdownMenuItem @click="editStockSalesPrice(row.data.id)" icon="fa-pencil">Edit price update</DropdownMenuItem>
            <DropdownMenuItem v-if="!row.data.isAutoGenerated" @click="deleteStockSalesPrice(row.data.id)" icon="fa-trash-alt">Delete price update</DropdownMenuItem>
          </ActionDropMenu>
        </td>
      </tr>
    </template>
  </DataTable>
</template>

<script>
import PriceRequestMixin from '@/modules/pricing/mixins/priceRequestMixin'

export default {
  name: 'PriceRequestStockSalesPriceList',
  mixins: [PriceRequestMixin],
  props: {
    stockpriceRequestGroupId: Number,
    isUnchangedList: Boolean,
    priceType: String,
    
    canEditSalesPrice: Boolean
  },
  computed: {
    dataURL() {
      var params = {
        filter: {}
      }
      if(this.isUnchangedList)
        params.isUnchanged = 1
      if(this.priceType)
        params.filter.priceType = this.priceType

      return `/pricing/requests/${this.stockpriceRequestGroupId}/stocksalesprices?` + $.param(params)
    },
  },
  data() {
    return {
      columnList: [
        { title: " ", data: " " },
        { title: "Stock", data: "stockName" },
        { title: "Info", data: "", sortable: false },
        { title: "Active", data: "isActive" },
        { title: "Price", data: "price" },
        { title: "Min Size Charge", data: "minChargeQuantity" },
        { title: "Min Price Per Item", data: "minChargePrice" },
        { title: "Min Invoice Charge", data: "minChargeInvoice" },
        { title: "Actions", data: " ", sortable: false },
      ]
    }
  },
  methods: {
    reloadData() {
      this.$refs.dataTable.reload()
    },
    priceHasField(stockSalesPrice, field) {
      return stockSalesPrice[field] !== null
    },
    priceInfoName(stockSalesPrice) {
      var output = []
      if(stockSalesPrice.stockPriceGroupName)
        output.push(stockSalesPrice.stockPriceGroupName)
      if(stockSalesPrice.servicePriceRangeName)
        output.push(stockSalesPrice.servicePriceRangeName)

      if(output.length > 0)
        return output.join(' - ')
      return 'General'
    },
    editStockSalesPrice(id) {
      this.$emit('editStockSalesPrice', id)
    },
    deleteStockSalesPrice(id) {
      this.$emit('deleteStockSalesPrice', id)
    }
  }
}
</script>